import { Card, Grid, Icon, AppBar, Tabs, Tab, Tooltip } from "@mui/material";
import breakpoints from "assets/theme/base/breakpoints";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useLocation, useNavigate } from "react-router-dom";
import { useMaterialUIController } from "context";

import { useEffect, useState } from "react";
import TransactionReports from "./components/TransactionReport";
import ReservationReports from "./components/ReservationReport";
import SubscriptionReports from "./components/SubscriptionReport";
import AutomatedReports from "layouts/automation/components/reports";
import RevenueSummary from "./components/RevenueSummary";
import CustomTooltip from "components/Common/CustomTooltip";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <MDBox sx={{ p: 3 }}>{children}</MDBox>}
    </div>
  );
}

const Reservation = () => {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;

  const location = useLocation();
  const navigate = useNavigate();
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [openTooltipId, setOpenTooltipId] = useState(null);

  const queryParams = new URLSearchParams(location.search);
  const activeTab = queryParams.get("tab");
  const [tabValue, setTabValue] = useState(
    activeTab ? activeTab : "transaction"
  );

  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }
    window.addEventListener("resize", handleTabsOrientation);
    handleTabsOrientation();
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, []);

  const handleSetTabValue = (event, newValue) => {
    setTabValue(newValue);
    queryParams.set("tab", newValue);
    navigate(`?${queryParams.toString()}`);
  };

  const tabInfo = {
    transaction:
      "View and export detailed transaction, revenue and reservation data reports with robust filtering options",
    subscription:
      "View and export a summary of subscription payment activity by location",
    automatedReport:
      "Schedule and manage recurring email reports for selected places, including transaction and refund data.",
    revenueSummary:
      "View an hourly breakdown of reservations, revenue, and related metrics for a selected place and date range.",
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={1}
                mt={-2}
                py={1}
                px={1}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow={sidenavColor}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Reports
                </MDTypography>
              </MDBox>

              <MDBox p={2}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <AppBar position="static">
                      <Tabs
                        orientation={tabsOrientation}
                        value={tabValue}
                        onChange={handleSetTabValue}
                        variant="scrollable"
                        scrollButtons="auto"
                      >
                        {/* TRANSACTION */}
                        <Tab
                          value="transaction"
                          icon={
                            <Icon fontSize="small" sx={{ mt: -0.25 }}>
                              article
                            </Icon>
                          }
                          label={
                            <MDBox display="flex" alignItems="center" gap={1}>
                              Transaction Report
                              <CustomTooltip
                                id="transaction"
                                title={tabInfo.transaction}
                                openTooltipId={openTooltipId}
                                setOpenTooltipId={setOpenTooltipId}
                              />
                            </MDBox>
                          }
                        />
                        {/* RESERVATION */}
                        {/* <Tab
                          value="reservation"
                          icon={
                            <Icon fontSize="small" sx={{ mt: -0.25 }}>
                              article
                            </Icon>
                          }
                          label={
                            <MDBox display="flex" alignItems="center" gap={1}>
                              Reservation Report
                              <CustomTooltip
                                id="transaction"
                                title={tabInfo.transaction}
                                openTooltipId={openTooltipId}
                                setOpenTooltipId={setOpenTooltipId}
                              />
                            </MDBox>
                          }
                        /> */}

                        {/* SUBSCRIPTION */}
                        <Tab
                          value="subscription"
                          icon={
                            <Icon fontSize="small" sx={{ mt: -0.25 }}>
                              assignment
                            </Icon>
                          }
                          label={
                            <MDBox display="flex" alignItems="center" gap={1}>
                              Subscription
                              <CustomTooltip
                                id="subscription"
                                title={tabInfo.subscription}
                                openTooltipId={openTooltipId}
                                setOpenTooltipId={setOpenTooltipId}
                              />
                            </MDBox>
                          }
                        />

                        {/* AUTOMATED */}
                        <Tab
                          value="automatedReport"
                          icon={
                            <Icon fontSize="small" sx={{ mt: -0.25 }}>
                              autorenew
                            </Icon>
                          }
                          label={
                            <MDBox display="flex" alignItems="center" gap={1}>
                              Automated Report
                              <CustomTooltip
                                id="automatedReport"
                                title={tabInfo.automatedReport}
                                openTooltipId={openTooltipId}
                                setOpenTooltipId={setOpenTooltipId}
                              />
                            </MDBox>
                          }
                        />

                        {/* REVENUE SUMMARY */}
                        <Tab
                          value="revenueSummary"
                          icon={
                            <Icon fontSize="small" sx={{ mt: -0.25 }}>
                              bar_chart
                            </Icon>
                          }
                          label={
                            <MDBox display="flex" alignItems="center" gap={1}>
                              Revenue Summary
                              <CustomTooltip
                                id="revenueSummary"
                                title={tabInfo.revenueSummary}
                                openTooltipId={openTooltipId}
                                setOpenTooltipId={setOpenTooltipId}
                              />
                            </MDBox>
                          }
                        />
                      </Tabs>
                    </AppBar>

                    {/* PANELS */}
                    <TabPanel value={tabValue} index="transaction">
                      <TransactionReports />
                    </TabPanel>
                    {/* <TabPanel value={tabValue} index="reservation">
                      <ReservationReports />
                    </TabPanel> */}
                    <TabPanel value={tabValue} index="subscription">
                      <SubscriptionReports />
                    </TabPanel>
                    <TabPanel value={tabValue} index="automatedReport">
                      <AutomatedReports />
                    </TabPanel>
                    <TabPanel value={tabValue} index="revenueSummary">
                      <RevenueSummary />
                    </TabPanel>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
};

export default Reservation;
